exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.search-control[data-v-29b0712d] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  position: relative;\n}\n.search-control input[data-v-29b0712d] {\n    -ms-flex: 1;\n        flex: 1;\n}\n.search-control input[data-v-29b0712d]:has(+ button) {\n      padding-right: calc(8px * 2 + 32px);\n}\n.search-control .clear[data-v-29b0712d] {\n    position: absolute;\n    right: 8px;\n    width: 32px;\n    height: 32px;\n    aspect-ratio: 1;\n    border: none;\n    background-color: inherit;\n    cursor: pointer;\n}\n.search-control .clear svg[data-v-29b0712d] {\n      width: 18px;\n      height: 18px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-29b0712d","scoped":true,"hasInlineConfig":false}!./~/sass-loader?{}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/components/search.vue
// module id = 583
// module chunks = 0